export default "__VITE_ASSET__Cd0YyYuU__"